/*************************************************/
/* VIDEO                                         */
/*************************************************/
import customEventsNames from './../customEventsNames';

export function video() {
    const videoPlayerSelectors = ['.video-item__player', '.panel-video-item__player'];
    const modalVideoPlayerId = '#videoModal';
    const videoPlayerPlayingClasses = ['video-item__player--playing', 'panel-video-item__player--playing'];
    const hiddenClass = "video-player__hidden";
    const videoPlayerInstances = document.querySelectorAll(".video-player");

    const initVideoPlayer = (playerElement) => {
        const elements = {
            playButton: playerElement.querySelector(".video-item__icon-container"),
            playButtonWebsite: playerElement.querySelector(".video-player__icon-container"),
            clickedVideo: playerElement.querySelector(".video-player__clicked"),
        };

        if (!elements.playButton || !elements.clickedVideo || !elements.playButtonWebsite) {
            return; // Exit if critical elements are missing
        }

        elements.playButton.addEventListener("click", () => {
            // Show the clicked video and play it
            elements.clickedVideo.classList.remove(hiddenClass);
            const videoElement = elements.clickedVideo.querySelector(".video-item__player-selector");

            if (videoElement) {
                videoElement.click();
            }
        });

        elements.playButtonWebsite.addEventListener("click", () => {
            // Show the clicked video and play it
            elements.clickedVideo.classList.remove(hiddenClass);
            const videoElement = elements.clickedVideo.querySelector(".video-item__player-selector");

            if (videoElement) {
                videoElement.click();
            }
        });
    };

    videoPlayerInstances.forEach((instance) => {
        initVideoPlayer(instance);
    });

    const init = function () {
        const playYoutubeVideo = (playerId, videoId) => {
            var iterations = 0;
            var loadViewTimer = setInterval(() => {
                if (youtubeLoaded) {
                    clearInterval(loadViewTimer);
                    let ytplayer = new YT.Player(playerId, {
                        height: '100%',
                        width: '100%',
                        videoId: videoId,
                        host: 'https://www.youtube-nocookie.com',
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        },
                        playerVars: {
                            showinfo: 0,
                            rel: 0
                        }
                    });
                } else {
                    iterations++;
                }

                //Lets try for 10 seconds
                if (iterations === 100) {
                    clearInterval(loadViewTimer);
                }

            }, 50);
        }

        const playVimeoVideo = (playerId, vimeoUrl) => {
            var iterations = 0;
            var loadViewTimer = setInterval(() => {
                if (vimeoLoaded) {
                    clearInterval(loadViewTimer);
                    let vimeoPlayer = new Vimeo.Player(playerId, {
                        url: vimeoUrl,
                        dnt: 1,
                    });
                    vimeoPlayer.on('play', onPlayerReadyVimeo);
                    vimeoPlayer.on('ended', onPlayerStateChangeVimeo);
                    vimeoPlayer.play();
                } else {
                    iterations++;
                }

                //Lets try for 10 seconds
                if (iterations === 100) {
                    clearInterval(loadViewTimer);
                }

            }, 50);
        }

        const playVideo = (playerId) => {
            const player = document.getElementById(playerId);
            if (player.tagName == 'VIDEO') {
                player.play();

            } else {
                player.querySelector('video').play();
            }

            const videoPlayerElement = player.closest(videoPlayerSelectors.join(','));
            if (videoPlayerElement) {
                videoPlayerPlayingClasses.forEach(cls => videoPlayerElement.classList.add(cls));
            }
            const videoStartedPlayingInModalEvent = new Event(customEventsNames.videoPlayingInModal);
            document.querySelector(modalVideoPlayerId).dispatchEvent(videoStartedPlayingInModalEvent);
        }

        const onPlayerReady = event => {
            const player = document.querySelector(`#player${event.target.playerInfo.videoData.video_id}`);
            const videoStartedPlayingInModalEvent = new Event(customEventsNames.videoPlayingInModal);
            document.querySelector(modalVideoPlayerId).dispatchEvent(videoStartedPlayingInModalEvent);

            const videoPlayerElement = player.closest(videoPlayerSelectors.join(','));
            if (videoPlayerElement) {
                videoPlayerPlayingClasses.forEach(cls => videoPlayerElement.classList.add(cls));

                if (videoPlayerElement.dataset.autoplay == 'true') {
                    event.target.mute();
                }
            }
            event.target.playVideo();
        }

        const onPlayerReadyVimeo = event => {
            const player = event.target;
            const videoStartedPlayingInModalEvent = new Event(customEventsNames.videoPlayingInModal);
            document.querySelector(modalVideoPlayerId).dispatchEvent(videoStartedPlayingInModalEvent);
            const videoPlayerElement = player.closest(videoPlayerSelectors.join(','));

            if (videoPlayerElement) {
                videoPlayerPlayingClasses.forEach(cls => videoPlayerElement.classList.add(cls));
            }
        }

        const onPlayerStateChange = event => {
            if (event.data === YT.PlayerState.ENDED) {
                const player = document.querySelector(`#player${event.target.playerInfo.videoData.video_id}`);
                const videoPlayerElement = player.closest(videoPlayerSelectors.join(','));
                if (videoPlayerElement) {
                    videoPlayerPlayingClasses.forEach(cls => videoPlayerElement.classList.remove(cls));
                }
            }
        }

        const onPlayerStateChangeVimeo = event => {
            const player = event.target;
            const videoPlayerElement = player.closest(videoPlayerSelectors.join(','));
            if (videoPlayerElement) {
                videoPlayerPlayingClasses.forEach(cls => videoPlayerElement.classList.add(cls));
            }
        }

        document.addEventListener(customEventsNames.playVideoInModal, e => {
            if (e.target.id === 'modalplayer') {
                playVideo(e.detail.playerId);
            }
        });
        document.addEventListener(customEventsNames.playYoutubeVideoInModal, e => {
            if (e.target.id === 'modalplayer') {
                playYoutubeVideo(e.detail.playerId, e.detail.videoId);
            }
        }, false);

        document.addEventListener(customEventsNames.playVimeoInModal, e => {
            if (e.target.id === 'modalplayer') {
                playVimeoVideo(e.detail.playerId, e.detail.vimeoUrl);
            }
        }, false);

        document.addEventListener(customEventsNames.closeModal, e => {
            document.querySelector(modalVideoPlayerId).classList.remove('open');
            if (e.target.id === modalVideoPlayerId) {
                document.querySelector(videoPlayerSelectors.join(',')).classList.remove(videoPlayerPlayingClasses.join(' '));
            }
        }, false);

        const videoPlayerActionHandler = (e) => {
            const videoItem = e.target.closest(videoPlayerSelectors.join(','));
            if (videoItem) {
                e.preventDefault();

                //Check if we are inside a content slider on the website, and fire relevant event
                const parentSlider = videoItem.closest('.content-slider-website');
                if (parentSlider) {
                    parentSlider.dispatchEvent(new Event(customEventsNames.videoStartedPlayingInSlider));
                }

                let videoId = videoItem.dataset.videoId;
                const playerId = videoItem.dataset.playerId;
                let vimeoUrl = videoItem.dataset.vimeoVideoUrl;

                let videoSources = videoItem.dataset.videosources;
                let videoTypes = videoItem.dataset.videotypes;
                let autoplay = videoItem.dataset.autoplay == 'true';

                // Hide the closest .image-cover-wrap
                if (!document.querySelector(".website")) {
                    const imageCoverWrap = videoItem.querySelector('.image-cover-wrap');
                    if (imageCoverWrap) {
                        imageCoverWrap.style.display = 'none';
                    }

                    const videoIcon = videoItem.querySelector(".video-item__icon-container");
                    if (videoIcon) {
                        videoIcon.style.display = 'none';
                    }
                } else if (autoplay) {
                    const imageCoverWrap = videoItem.querySelector('.image-cover-wrap');
                    if (imageCoverWrap) {
                        imageCoverWrap.style.display = 'none';
                    }
                }

                if (videoSources && videoTypes) {
                    videoSources = videoSources.split(',');
                    videoTypes = videoTypes.split(',');

                    const modalId = videoItem.dataset.target;
                    const videoElement = document.createElement('video');
                    videoElement.controls = true;

                    if (autoplay) {
                        videoElement.autoplay = true;
                        videoElement.loop = true;
                        videoElement.controls = false;
                        videoElement.muted = true;
                        videoElement.playsInline = true;
                        videoElement.play();

                        if (document.querySelector(".website") && videoItem.closest(".video-player")) {
                            videoElement.controls = true;
                        }
                    }

                    for (let i = 0; i < videoSources.length; i++) {
                        const sourceElement = document.createElement('source');
                        sourceElement.setAttribute('src', videoSources[i]);
                        sourceElement.setAttribute('type', videoTypes[i]);
                        videoElement.appendChild(sourceElement)
                    }

                    if (typeof modalId !== 'undefined' && modalId !== '') {
                        var openModalEvent = new CustomEvent(customEventsNames.openModal, {
                            detail: {
                                modalId: modalId,
                                videoElement: videoElement,
                                sliderInitiatorId: parentSlider?.id ?? null
                            }
                        });

                        if (!document.querySelector(modalVideoPlayerId).classList.contains('open')) {
                            document.querySelector(modalVideoPlayerId).classList.add('open');
                            document.querySelector(modalVideoPlayerId).dispatchEvent(openModalEvent);
                        }

                    } else {

                        document.getElementById(playerId).replaceChildren(videoElement);
                        playVideo(playerId);
                    }
                }
                else if (typeof videoId != undefined && videoId != null && videoId != '') {
                    if (!Cookiebot.consent.marketing) {
                        CookieConsent.renew();
                    } else {
                        const tag = document.createElement('script');
                        tag.src = 'https://www.youtube.com/iframe_api';
                        const firstScriptTag = document.getElementsByTagName('script')[0];
                        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


                        //If video id is not set, it's probably a link from a RTE
                        if (typeof videoId === undefined) {
                            videoId = videoItem.querySelector('a').getAttribute('href');
                            if (videoId && videoId.indexOf('/') === 0 && videoId.length > 1) {
                                videoId = videoId.substr(1);
                            }
                        }
                        if (videoId) {
                            const modalId = videoItem.dataset.target;
                            if (typeof modalId !== 'undefined' && modalId !== '') {
                                var openModalEvent = new CustomEvent(customEventsNames.openModal, {
                                    detail: {
                                        modalId: modalId,
                                        videoId: videoId,
                                        sliderInitiatorId: parentSlider?.id ?? null
                                    }
                                });

                                document.querySelector(modalVideoPlayerId).dispatchEvent(openModalEvent);

                            } else {
                                playYoutubeVideo(playerId, videoId);
                            }
                        } else {
                            console.error('Video not found');
                        }
                    }
                } else if (typeof vimeoUrl != undefined && vimeoUrl != null && vimeoUrl != '') {
                    const tag = document.createElement('script');
                    tag.src = 'https://player.vimeo.com/api/player.js';
                    tag.onload = () => { vimeoLoaded = true; };
                    const firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                    if (vimeoUrl) {
                        const modalId = videoItem.dataset.target;
                        if (typeof modalId !== 'undefined' && modalId !== '') {
                            var openModalEvent = new CustomEvent(customEventsNames.openModal, {
                                detail: {
                                    modalId: modalId,
                                    vimeoUrl: vimeoUrl,
                                    sliderInitiatorId: parentSlider?.id ?? null
                                }
                            });

                            if (!document.querySelector(modalVideoPlayerId).classList.contains('open')) {
                                document.querySelector(modalVideoPlayerId).classList.add('open');
                                document.querySelector(modalVideoPlayerId).dispatchEvent(openModalEvent);
                            }

                        } else {
                            playVimeoVideo(playerId, vimeoUrl);
                        }
                    } else {
                        console.error('Video not found');
                    }
                }
            }
        }

        const videoPlayers = document.querySelectorAll(videoPlayerSelectors.join(','));
        if (videoPlayers.length > 0) {
            videoPlayers.forEach(player => {

                document.addEventListener("DOMContentLoaded", function () {
                    if (player.dataset.autoplay) {
                        player.click();
                    }
                });

                player.addEventListener('click', e => {
                    //Only play the video if it's not already playing
                    const videoPlayer = player.querySelector('video');
                    if (!videoPlayer) {
                        videoPlayerActionHandler(e);
                    }
                });

                player.addEventListener('keyup', e => {
                    e.preventDefault();
                    if (e.key === 'Enter') {
                        videoPlayerActionHandler(e);
                    }
                });
            })
        }

    };

    init();
}
